'use strict';

/* Product modal */
(function ProductModal() {
  var modal = nodeList('[data-js-details-modal]')[0];
  var triggerOpen = nodeList('[data-js-product-details]');
  var triggerClose = nodeList('[data-js-details-close]');
  
  triggerOpen.forEach(function(node){
    node.addEventListener('click', open);
  });
  
  triggerClose.forEach(function(node){
    node.addEventListener('click', close);
  });
  
  function open(node) {
    modal.removeAttribute('hidden');
    initSwiper();
  }
  
  function close() {
    modal.setAttribute('hidden', true)
  }
  
  function initSwiper() {
    var instance = document.querySelector('[data-product-gallery-configurations]');
    if (!instance) return;
    
    if (!instance.classList.contains('swiper-container-initialized')) {
       var swiper = new Swiper('[data-product-gallery-configurations]', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesPerView: 2,
        navigation: {
          nextEl: '.slider-btn-next',
          prevEl: '.slider-btn-prev'
        },
         breakpoints: {
          600: {
            slidesPerView: 3
          },
          860: {
            slidesPerView: 5
          }
        }
      });
    }
  }
})();

function closeOtherSelectorPanels(activeSelector) {
  nodeList('[data-fabric-selector], [data-finish-selector]').forEach(function(selector) {
    if (selector === activeSelector) return;

    var panel = selector.querySelector('[data-fabric-panel], [data-finish-panel]');
    var overlay = selector.querySelector('[data-fabric-panel-overlay], [data-finish-panel-overlay]');
    var gridView = selector.querySelector('[data-fabric-grid-view], [data-finish-grid-view]');
    var detailView = selector.querySelector('[data-fabric-detail-view], [data-finish-detail-view]');

    selector.classList.remove('is-panel-open');

    if (panel) {
      panel.classList.remove('is-closing', 'is-detail-view');
      panel.setAttribute('hidden', true);
    }

    if (overlay) {
      overlay.classList.remove('is-closing');
      overlay.setAttribute('hidden', true);
    }

    if (gridView) gridView.removeAttribute('hidden');
    if (detailView) detailView.setAttribute('hidden', true);
  });
}

/* Advanced fabric selector */
(function ProductFabricSelector() {
  var selector = document.querySelector('[data-fabric-selector]');
  if (!selector) return;

  var panel = selector.querySelector('[data-fabric-panel]');
  var panelOverlay = selector.querySelector('[data-fabric-panel-overlay]');
  var gridView = selector.querySelector('[data-fabric-grid-view]');
  var detailView = selector.querySelector('[data-fabric-detail-view]');
  var detailClose = selector.querySelector('[data-fabric-details-close]');
  var detailImage = selector.querySelector('[data-fabric-detail-image]');
  var detailTitle = selector.querySelector('[data-fabric-detail-title]');
  var detailMeta = selector.querySelector('[data-fabric-detail-meta]');
  var detailDescription = selector.querySelector('[data-fabric-detail-description]');
  var detailQuote = selector.querySelector('[data-fabric-detail-quote]');
  var triggerOpen = nodeList('[data-fabric-panel-open]');
  var triggerClose = selector.querySelector('[data-fabric-panel-close]');
  var closingTimer = null;
  var selectedLabel = selector.querySelector('[data-selected-fabric-label]');
  var selectedImage = selector.querySelector('[data-selected-fabric-image]');
  var fabricItems = nodeList('[data-fabric-option]');
  var dynamicFeaturedSections = selector.querySelector('[data-fabric-dynamic-featured-sections]');
  var dynamicSections = selector.querySelector('[data-fabric-dynamic-sections]');
  var dynamicStatus = selector.querySelector('[data-fabric-dynamic-status]');
  var currentDetailItem = null;
  var selectedFabric = null;
  var autoOpenQuote = true;
  var storefrontToken = selector.getAttribute('data-storefront-api-token') || '';
  var storefrontApiVersion = selector.getAttribute('data-storefront-api-version') || '2026-04';
  var fabricPaginationPages = parseInt(selector.getAttribute('data-fabric-pagination-pages'), 10) || 1;
  var fabricPaginationParam = selector.getAttribute('data-fabric-pagination-param') || 'page';
  var productVendor = selector.getAttribute('data-product-vendor') || '';
  var allowedFabricVendorHandles = (selector.getAttribute('data-allowed-fabric-vendors') || '').split('|').filter(Boolean);
  var fabricOptionTokens = (selector.getAttribute('data-fabric-option-tokens') || '').split('|').filter(Boolean);
  var dynamicFabricsLoaded = false;
  var dynamicFabricsLoading = false;
  var showFabricVendor = false;
  var showFabricSku = false;

  triggerOpen.forEach(function(node) {
    node.addEventListener('click', open);
  });
  triggerClose.addEventListener('click', close);
  panelOverlay.addEventListener('click', close);
  detailClose.addEventListener('click', showGridView);
  if (detailQuote) {
    detailQuote.addEventListener('click', function() {
      if (currentDetailItem) selectFabric(currentDetailItem);
    });
  }
  fabricItems.forEach(function(item) {
    var selectButton = item.querySelector('[data-fabric-select-option]');
    var detailsButton = item.querySelector('[data-fabric-details-open]');

    if (selectButton) {
      selectButton.addEventListener('click', partial(selectFabric, item));
    }

    if (detailsButton) {
      detailsButton.addEventListener('click', partial(showDetails, item));
    }
  });

  function open() {
    window.clearTimeout(closingTimer);
    closeOtherSelectorPanels(selector);
    selector.classList.add('is-panel-open');
    panel.classList.remove('is-closing');
    panelOverlay.classList.remove('is-closing');
    showGridView();
    panelOverlay.removeAttribute('hidden');
    panel.removeAttribute('hidden');
  }

  function close() {
    panel.classList.add('is-closing');
    panelOverlay.classList.add('is-closing');

    closingTimer = window.setTimeout(function() {
      showGridView();
      panelOverlay.setAttribute('hidden', true);
      panel.setAttribute('hidden', true);
      panel.classList.remove('is-closing');
      panelOverlay.classList.remove('is-closing');
      selector.classList.remove('is-panel-open');
      document.dispatchEvent(new CustomEvent('fabric:panel-close'));
    }, 220);
  }

  function showGridView() {
    panel.classList.remove('is-detail-view');
    gridView.removeAttribute('hidden');
    detailView.setAttribute('hidden', true);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function fabricImageMarkup(src, alt, size, loading) {
    if (!src) return '';
    var dimension = size || 180;
    return '<img src="' + escapeHtml(src) + '" width="' + dimension + '" height="' + dimension + '" alt="' + escapeHtml(alt || '') + '" loading="' + (loading || 'lazy') + '" decoding="async">';
  }

  function normalizeHandle(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function isAllowedFabricVendor(vendor) {
    var vendorHandle = normalizeHandle(vendor);
    return allowedFabricVendorHandles.indexOf(vendorHandle) !== -1;
  }

  function isFeaturedFabric(fabric) {
    return fabricOptionTokens.indexOf(normalizeHandle(fabric.name)) !== -1;
  }

  function getVendorFabricCount() {
    var count = 0;

    fabricItems.forEach(function(item) {
      var fabricVendor = item.getAttribute('data-fabric-vendor') || '';
      var fabricName = item.getAttribute('data-fabric-name') || '';

      if (fabricName !== 'COM' && isAllowedFabricVendor(fabricVendor)) {
        count += 1;
      }
    });

    return count;
  }

  function setDynamicStatus(message) {
    if (!dynamicStatus) return;

    if (!message) {
      dynamicStatus.setAttribute('hidden', true);
      dynamicStatus.textContent = '';
      return;
    }

    dynamicStatus.textContent = message;
    dynamicStatus.removeAttribute('hidden');
  }

  function getMetaobjectField(metaobject, key) {
    if (!metaobject || !metaobject.fields) return null;

    for (var i = 0; i < metaobject.fields.length; i += 1) {
      if (metaobject.fields[i].key === key) return metaobject.fields[i];
    }

    return null;
  }

  function getMetaobjectFieldValue(metaobject, key) {
    var field = getMetaobjectField(metaobject, key);
    return field ? field.value || '' : '';
  }

  function getMetaobjectReferenceName(field) {
    if (!field || !field.reference || !field.reference.fields) return '';

    return getMetaobjectFieldValue(field.reference, 'name') || field.reference.handle || '';
  }

  function normalizeStorefrontFabric(metaobject) {
    var photoField = getMetaobjectField(metaobject, 'photo');
    var styleField = getMetaobjectField(metaobject, 'fabric_style');
    var detailImage = photoField && photoField.reference && photoField.reference.image ? photoField.reference.image.detailUrl || photoField.reference.image.url || '' : '';
    var summaryImage = photoField && photoField.reference && photoField.reference.image ? photoField.reference.image.summaryUrl || detailImage : '';

    return {
      name: getMetaobjectFieldValue(metaobject, 'name'),
      description: getMetaobjectFieldValue(metaobject, 'description'),
      vendor: getMetaobjectFieldValue(metaobject, 'vendor'),
      sku: getMetaobjectFieldValue(metaobject, 'sku'),
      retailPrice: getMetaobjectFieldValue(metaobject, 'retail_price'),
      cost: getMetaobjectFieldValue(metaobject, 'cost'),
      style: getMetaobjectReferenceName(styleField) || getMetaobjectFieldValue(metaobject, 'style') || 'Fabrics',
      summaryImage: summaryImage,
      detailImage: detailImage
    };
  }

  function normalizeRenderedFabric(item, styleName) {
    return {
      name: item.getAttribute('data-fabric-name') || '',
      description: item.getAttribute('data-fabric-description') || '',
      vendor: item.getAttribute('data-fabric-vendor') || '',
      sku: item.getAttribute('data-fabric-sku') || '',
      retailPrice: item.getAttribute('data-fabric-retail-price') || '',
      cost: item.getAttribute('data-fabric-cost') || '',
      style: styleName || 'Fabrics',
      summaryImage: item.getAttribute('data-fabric-image-summary') || '',
      detailImage: item.getAttribute('data-fabric-image-detail') || ''
    };
  }

  function createFabricItem(fabric) {
    var item = document.createElement('div');
    var button = document.createElement('button');
    var image = document.createElement('span');
    var name = document.createElement('span');

    item.className = 'fabric-selector__item';
    item.setAttribute('data-fabric-option', '');
    item.setAttribute('data-fabric-value', fabric.name);
    item.setAttribute('data-fabric-name', fabric.name);
    item.setAttribute('data-fabric-description', fabric.description || '');
    item.setAttribute('data-fabric-vendor', fabric.vendor || '');
    item.setAttribute('data-fabric-sku', fabric.sku || '');
    item.setAttribute('data-fabric-retail-price', fabric.retailPrice || '');
    item.setAttribute('data-fabric-cost', fabric.cost || '');
    item.setAttribute('data-fabric-image-summary', fabric.summaryImage || '');
    item.setAttribute('data-fabric-image-detail', fabric.detailImage || fabric.summaryImage || '');

    button.className = 'fabric-selector__select';
    button.type = 'button';
    button.title = fabric.name;
    button.setAttribute('data-fabric-select-option', '');
    button.addEventListener('click', partial(selectFabric, item));

    image.className = 'fabric-selector__image';
    image.innerHTML = fabric.summaryImage ? fabricImageMarkup(fabric.summaryImage, fabric.name, 180, 'lazy') : '<span class="fabric-selector__image-placeholder"></span>';

    name.className = 'fabric-selector__name uppercase text-13';
    name.textContent = fabric.name;

    button.appendChild(image);
    button.appendChild(name);
    item.appendChild(button);

    if (fabric.description || showFabricVendor && fabric.vendor || showFabricSku && fabric.sku) {
      var detailsButton = document.createElement('button');
      detailsButton.className = 'fabric-selector__details-toggle text-sm underline';
      detailsButton.type = 'button';
      detailsButton.setAttribute('data-fabric-details-open', '');
      detailsButton.textContent = 'Details';
      detailsButton.addEventListener('click', partial(showDetails, item));
      item.appendChild(detailsButton);
    }

    return item;
  }

  function findFabricSection(headingText) {
    var sections = nodeList('.fabric-selector__style-section', selector);
    for (var i = 0; i < sections.length; i += 1) {
      var heading = sections[i].querySelector('.fabric-selector__style-heading');
      if (heading && heading.textContent.trim() === headingText) return sections[i];
    }

    return null;
  }

  function renderStorefrontFabrics(fabrics) {
    var grouped = {};
    var styleNames = [];
    var featured = [];

    if (!dynamicSections) return;
    if (dynamicFeaturedSections) dynamicFeaturedSections.innerHTML = '';
    dynamicSections.innerHTML = '';

    fabrics.forEach(function(fabric) {
      if (isFeaturedFabric(fabric)) {
        featured.push(fabric);
        return;
      }
      var styleName = fabric.style || 'Fabrics';

      if (!grouped[styleName]) {
        grouped[styleName] = [];
        styleNames.push(styleName);
      }

      grouped[styleName].push(fabric);
    });

    if (featured.length) {
      var featuredSection = findFabricSection('Featured Coverings');
      var featuredGrid = featuredSection ? featuredSection.querySelector('.fabric-selector__grid') : null;

      if (!featuredSection) {
        featuredSection = document.createElement('div');
        var featuredHeading = document.createElement('h3');
        featuredGrid = document.createElement('div');

        featuredSection.className = 'fabric-selector__style-section fabric-selector__style-section--featured';
        featuredHeading.className = 'fabric-selector__style-heading uppercase text-13';
        featuredHeading.textContent = 'Featured Coverings';
        featuredGrid.className = 'fabric-selector__grid';
        featuredSection.appendChild(featuredHeading);
        featuredSection.appendChild(featuredGrid);
        (dynamicFeaturedSections || dynamicSections).appendChild(featuredSection);
      }

      featured.sort(function(a, b) { return a.name.localeCompare(b.name); }).forEach(function(fabric) {
        featuredGrid.appendChild(createFabricItem(fabric));
      });
    }

    styleNames.sort(function(a, b) {
      return a.localeCompare(b);
    });

    styleNames.forEach(function(styleName) {
      var section = findFabricSection(styleName);
      var grid = section ? section.querySelector('.fabric-selector__grid') : null;

      if (!section) {
        section = document.createElement('div');
        var heading = document.createElement('h3');
        grid = document.createElement('div');

        section.className = 'fabric-selector__style-section';
        heading.className = 'fabric-selector__style-heading uppercase text-13';
        heading.textContent = styleName;
        grid.className = 'fabric-selector__grid';
        section.appendChild(heading);
        section.appendChild(grid);
        dynamicSections.appendChild(section);
      }

      grouped[styleName].sort(function(a, b) {
        return a.name.localeCompare(b.name);
      }).forEach(function(fabric) {
        grid.appendChild(createFabricItem(fabric));
      });

    });

    fabricItems = nodeList('[data-fabric-option]');
  }

  function fetchStorefrontMetaobjects(cursor, metaobjects) {
    var query = [
      'query FabricMetaobjects($cursor: String) {',
      '  metaobjects(type: "fabric", first: 250, after: $cursor) {',
      '    pageInfo { hasNextPage endCursor }',
      '    nodes {',
      '      handle',
      '      fields {',
      '        key',
      '        value',
      '        reference {',
      '          ... on Metaobject { handle fields { key value } }',
      '          ... on MediaImage {',
      '            image {',
      '              url',
      '              summaryUrl: url(transform: { maxWidth: 180 })',
      '              detailUrl: url(transform: { maxWidth: 720 })',
      '            }',
      '          }',
      '        }',
      '      }',
      '    }',
      '  }',
      '}'
    ].join('\\n');

    return fetch('/api/' + storefrontApiVersion + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontToken
      },
      body: JSON.stringify({
        query: query,
        variables: {
          cursor: cursor || null
        }
      })
    }).then(function(response) {
      return response.json();
    }).then(function(json) {
      if (json.errors) throw new Error(json.errors.map(function(error) { return error.message; }).join(', '));

      var page = json.data && json.data.metaobjects;
      var nextMetaobjects = metaobjects.concat(page && page.nodes ? page.nodes : []);

      if (page && page.pageInfo && page.pageInfo.hasNextPage) {
        return fetchStorefrontMetaobjects(page.pageInfo.endCursor, nextMetaobjects);
      }

      return nextMetaobjects;
    });
  }

  function fabricPageUrl(page) {
    var url = new URL(window.location.href);
    url.searchParams.set(fabricPaginationParam, page);
    return url.toString();
  }

  function fetchRenderedFabricPage(page) {
    return fetch(fabricPageUrl(page), {
      credentials: 'same-origin'
    }).then(function(response) {
      return response.text();
    }).then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fetchedSelector = doc.querySelector('[data-fabric-selector]');
      var fabrics = [];

      if (!fetchedSelector) return fabrics;

      nodeList('.fabric-selector__style-section', fetchedSelector).forEach(function(section) {
        var styleName = section.querySelector('.fabric-selector__style-heading') ? section.querySelector('.fabric-selector__style-heading').textContent.trim() : 'Fabrics';

        if (styleName === 'COM') return;

        nodeList('[data-fabric-option]', section).forEach(function(item) {
          var fabricName = item.getAttribute('data-fabric-name') || '';
          var fabricVendor = item.getAttribute('data-fabric-vendor') || '';

          if (fabricName !== 'COM' && isAllowedFabricVendor(fabricVendor)) {
            fabrics.push(normalizeRenderedFabric(item, styleName));
          }
        });
      });

      return fabrics;
    });
  }

  function fetchRenderedVendorFabrics() {
    var requests = [];

    for (var page = 2; page <= fabricPaginationPages; page += 1) {
      requests.push(fetchRenderedFabricPage(page));
    }

    if (!requests.length) return Promise.resolve([]);

    return Promise.all(requests).then(function(results) {
      return results.reduce(function(fabrics, pageFabrics) {
        return fabrics.concat(pageFabrics);
      }, []);
    });
  }

  function loadDynamicVendorFabrics() {
    if (dynamicFabricsLoaded || dynamicFabricsLoading || !dynamicSections) return;
    if (fabricPaginationPages <= 1 && !storefrontToken) return;

    dynamicFabricsLoading = true;
    setDynamicStatus('');

    fetchRenderedVendorFabrics().then(function(renderedFabrics) {
      if (renderedFabrics.length || !storefrontToken) return renderedFabrics;

      return fetchStorefrontMetaobjects(null, []).then(function(metaobjects) {
        return metaobjects
          .map(normalizeStorefrontFabric)
          .filter(function(fabric) {
            return fabric.name && isAllowedFabricVendor(fabric.vendor);
          });
      });
    }).then(function(fabrics) {
      var uniqueFabricNames = {};
      var existingVendorFabricCount = getVendorFabricCount();

      fabricItems.forEach(function(item) {
        var fabricName = item.getAttribute('data-fabric-name') || '';
        var fabricVendor = item.getAttribute('data-fabric-vendor') || '';

        if (fabricName !== 'COM' && isAllowedFabricVendor(fabricVendor)) {
          uniqueFabricNames[normalizeHandle(fabricName)] = true;
        }
      });

      var filteredFabrics = fabrics
        .filter(function(fabric) {
          return fabric.name && isAllowedFabricVendor(fabric.vendor);
        })
        .filter(function(fabric) {
          var key = normalizeHandle(fabric.name);
          if (uniqueFabricNames[key]) return false;
          uniqueFabricNames[key] = true;
          return true;
        });

      dynamicFabricsLoaded = true;
      dynamicFabricsLoading = false;

      if (!filteredFabrics.length) {
        if (!existingVendorFabricCount) {
          setDynamicStatus('No coverings found for ' + productVendor + '.');
        }
        return;
      }

      renderStorefrontFabrics(filteredFabrics);
      setDynamicStatus('');
    }).catch(function(error) {
      dynamicFabricsLoading = false;
      setDynamicStatus('Coverings could not be loaded. Please try again.');
      if (window.console) console.warn('Fabric selector Storefront API fallback failed:', error);
    });
  }

  if (window.requestIdleCallback) {
    window.requestIdleCallback(loadDynamicVendorFabrics);
  } else {
    window.setTimeout(loadDynamicVendorFabrics, 250);
  }

  function showDetails(item) {
    var fabricName = item.getAttribute('data-fabric-name') || '';
    var fabricDescription = item.getAttribute('data-fabric-description') || '';
    var fabricVendor = showFabricVendor ? item.getAttribute('data-fabric-vendor') || '' : '';
    var fabricSku = item.getAttribute('data-fabric-sku') || '';
    var fabricImage = item.getAttribute('data-fabric-image-detail') || item.getAttribute('data-fabric-image-summary') || '';
    var meta = [];

    if (fabricVendor) meta.push('Vendor: ' + fabricVendor);
    if (fabricSku) meta.push('SKU: ' + fabricSku);

    currentDetailItem = item;
    detailTitle.textContent = fabricName;
    detailDescription.textContent = fabricDescription;
    detailMeta.innerHTML = meta.map(function(item) {
      return '<span>' + item + '</span>';
    }).join('');
    detailImage.innerHTML = fabricImageMarkup(fabricImage, fabricName, 720, 'lazy');

    panel.classList.add('is-detail-view');
    gridView.setAttribute('hidden', true);
    detailView.removeAttribute('hidden');
  }

  function selectFabric(item) {
    selectedFabric = getFabricData(item);
    updateSelectedFabric(item);
    close();

    if (autoOpenQuote) {
      document.dispatchEvent(new CustomEvent('fabric:quote-request', {
        detail: selectedFabric
      }));
    }
  }

  function updateSelectedFabric(item) {
    var fabricName = selectedFabric ? selectedFabric.name : 'Select Covering';
    var fabricDescription = selectedFabric ? selectedFabric.description : '';
    var fabricImage = selectedFabric ? selectedFabric.summaryImage : '';

    selectedLabel.textContent = fabricName;
    selector.setAttribute('data-selected-fabric', fabricName);
    selector.setAttribute('data-selected-fabric-description', fabricDescription || '');
    selector.setAttribute('data-selected-fabric-retail-price', selectedFabric ? selectedFabric.retailPrice : '');
    selector.setAttribute('data-selected-fabric-vendor', selectedFabric ? selectedFabric.vendor : '');
    selector.setAttribute('data-selected-fabric-sku', selectedFabric ? selectedFabric.sku : '');
    selector.setAttribute('data-selected-fabric-image', selectedFabric ? selectedFabric.image : '');

    if (selectedImage) {
      selectedImage.innerHTML = fabricImageMarkup(fabricImage, fabricName, 180, 'lazy');
    }

    fabricItems.forEach(function(item) {
      item.classList.toggle('is-selected', selectedFabric && item.getAttribute('data-fabric-value') === selectedFabric.value);
    });

    document.dispatchEvent(new CustomEvent('fabric:change', {
      detail: {
        name: fabricName,
        value: selectedFabric ? selectedFabric.value : '',
        description: fabricDescription || '',
        retailPrice: selectedFabric ? selectedFabric.retailPrice : '',
        image: selectedFabric ? selectedFabric.image : ''
      }
    }));
  }

  function getFabricData(item) {
    var detailImage = item.getAttribute('data-fabric-image-detail') || '';
    var summaryImage = item.getAttribute('data-fabric-image-summary') || detailImage;

    return {
      value: item.getAttribute('data-fabric-value') || '',
      name: item.getAttribute('data-fabric-name') || '',
      description: item.getAttribute('data-fabric-description') || '',
      vendor: item.getAttribute('data-fabric-vendor') || '',
      sku: item.getAttribute('data-fabric-sku') || '',
      retailPrice: item.getAttribute('data-fabric-retail-price') || '',
      image: detailImage || summaryImage,
      summaryImage: summaryImage
    };
  }
})();

/* Advanced finish selector */
(function ProductFinishSelector() {
  var selectors = nodeList('[data-finish-selector]');
  if (!selectors.length) return;

  selectors.forEach(initFinishSelector);

  function initFinishSelector(selector) {
    var panel = selector.querySelector('[data-finish-panel]');
    var panelOverlay = selector.querySelector('[data-finish-panel-overlay]');
    var gridView = selector.querySelector('[data-finish-grid-view]');
    var detailView = selector.querySelector('[data-finish-detail-view]');
    var detailClose = selector.querySelector('[data-finish-details-close]');
    var detailImage = selector.querySelector('[data-finish-detail-image]');
    var detailTitle = selector.querySelector('[data-finish-detail-title]');
    var detailMeta = selector.querySelector('[data-finish-detail-meta]');
    var detailDescription = selector.querySelector('[data-finish-detail-description]');
    var detailQuote = selector.querySelector('[data-finish-detail-quote]');
    var triggerOpen = nodeList('[data-finish-panel-open]', selector);
    var triggerClose = selector.querySelector('[data-finish-panel-close]');
    var selectedLabel = selector.querySelector('[data-selected-finish-label]');
    var selectedImage = selector.querySelector('[data-selected-finish-image]');
    var finishItems = nodeList('[data-finish-option]', selector);
    var dynamicSections = selector.querySelector('[data-finish-dynamic-sections]');
    var dynamicStatus = selector.querySelector('[data-finish-dynamic-status]');
    var optionName = selector.getAttribute('data-finish-option-name') || 'Finish';
    var finishType = selector.getAttribute('data-finish-type') || '';
    var defaultLabel = selectedLabel ? selectedLabel.textContent : 'Select Finish';
    var storefrontToken = selector.getAttribute('data-storefront-api-token') || '';
    var storefrontApiVersion = selector.getAttribute('data-storefront-api-version') || '2026-04';
    var finishPaginationPages = parseInt(selector.getAttribute('data-finish-pagination-pages'), 10) || 1;
    var finishPaginationParam = selector.getAttribute('data-finish-pagination-param') || 'page';
    var productVendor = selector.getAttribute('data-product-vendor') || '';
    var dynamicFinishesLoaded = false;
    var dynamicFinishesLoading = false;
    var closingTimer = null;
    var currentDetailItem = null;
    var selectedFinish = null;
    var autoOpenQuote = true;

    triggerOpen.forEach(function(node) {
      node.addEventListener('click', open);
    });
    if (triggerClose) triggerClose.addEventListener('click', close);
    if (panelOverlay) panelOverlay.addEventListener('click', close);
    if (detailClose) detailClose.addEventListener('click', showGridView);
    if (detailQuote) {
      detailQuote.addEventListener('click', function() {
        if (currentDetailItem) selectFinish(currentDetailItem);
      });
    }

    finishItems.forEach(function(item) {
      bindFinishItem(item);
    });

    loadDynamicVendorFinishes();

    function open() {
      window.clearTimeout(closingTimer);
      closeOtherSelectorPanels(selector);
      selector.classList.add('is-panel-open');
      panel.classList.remove('is-closing');
      panelOverlay.classList.remove('is-closing');
      showGridView();
      panelOverlay.removeAttribute('hidden');
      panel.removeAttribute('hidden');
    }

    function close() {
      panel.classList.add('is-closing');
      panelOverlay.classList.add('is-closing');

      closingTimer = window.setTimeout(function() {
        showGridView();
        panelOverlay.setAttribute('hidden', true);
        panel.setAttribute('hidden', true);
        panel.classList.remove('is-closing');
        panelOverlay.classList.remove('is-closing');
        selector.classList.remove('is-panel-open');
        document.dispatchEvent(new CustomEvent('finish:panel-close'));
      }, 220);
    }

    function showGridView() {
      panel.classList.remove('is-detail-view');
      gridView.removeAttribute('hidden');
      detailView.setAttribute('hidden', true);
    }

    function showDetails(item) {
      var finishName = item.getAttribute('data-finish-name') || '';
      var finishDescription = item.getAttribute('data-finish-description') || '';
      var finishVendor = item.getAttribute('data-finish-vendor') || '';
      var finishSku = item.getAttribute('data-finish-sku') || '';
      var finishCategory = item.getAttribute('data-finish-category') || '';
      var finishImage = item.getAttribute('data-finish-image-detail') || item.getAttribute('data-finish-image-summary') || '';
      var meta = [];

      if (finishType) meta.push('Type: ' + finishType);
      if (finishVendor) meta.push('Vendor: ' + finishVendor);
      if (finishCategory) meta.push('Category: ' + finishCategory);
      if (finishSku) meta.push('SKU: ' + finishSku);

      currentDetailItem = item;
      detailTitle.textContent = finishName;
      detailDescription.textContent = finishDescription;
      detailMeta.innerHTML = meta.map(function(item) {
        return '<span>' + escapeHtml(item) + '</span>';
      }).join('');
      detailImage.innerHTML = finishImageMarkup(finishImage, finishName, 720, 'lazy');

      panel.classList.add('is-detail-view');
      gridView.setAttribute('hidden', true);
      detailView.removeAttribute('hidden');
    }

    function bindFinishItem(item) {
      var selectButton = item.querySelector('[data-finish-select-option]');
      var detailsButton = item.querySelector('[data-finish-details-open]');

      if (selectButton && !selectButton.hasAttribute('data-finish-bound')) {
        selectButton.setAttribute('data-finish-bound', 'true');
        selectButton.addEventListener('click', partial(selectFinish, item));
      }

      if (detailsButton && !detailsButton.hasAttribute('data-finish-bound')) {
        detailsButton.setAttribute('data-finish-bound', 'true');
        detailsButton.addEventListener('click', partial(showDetails, item));
      }
    }

    function setDynamicStatus(message) {
      if (!dynamicStatus) return;

      if (!message) {
        dynamicStatus.setAttribute('hidden', true);
        dynamicStatus.textContent = '';
        return;
      }

      dynamicStatus.textContent = message;
      dynamicStatus.removeAttribute('hidden');
    }

    function getMetaobjectField(metaobject, key) {
      if (!metaobject || !metaobject.fields) return null;

      for (var i = 0; i < metaobject.fields.length; i += 1) {
        if (metaobject.fields[i].key === key) return metaobject.fields[i];
      }

      return null;
    }

    function getMetaobjectFieldValue(metaobject, key) {
      var field = getMetaobjectField(metaobject, key);
      return field ? field.value || '' : '';
    }

    function getMetaobjectReferenceName(field) {
      if (!field || !field.reference || !field.reference.fields) return '';

      return getMetaobjectFieldValue(field.reference, 'name') || field.reference.handle || '';
    }

    function normalizeStorefrontFinish(metaobject) {
      var photoField = getMetaobjectField(metaobject, 'photo');
      var typeField = getMetaobjectField(metaobject, 'finish_type');
      var categoryField = getMetaobjectField(metaobject, 'finish_category');
      var detailImage = photoField && photoField.reference && photoField.reference.image ? photoField.reference.image.detailUrl || photoField.reference.image.url || '' : '';
      var summaryImage = photoField && photoField.reference && photoField.reference.image ? photoField.reference.image.summaryUrl || detailImage : '';

      return {
        name: getMetaobjectFieldValue(metaobject, 'name'),
        description: getMetaobjectFieldValue(metaobject, 'description'),
        vendor: getMetaobjectFieldValue(metaobject, 'vendor'),
        sku: getMetaobjectFieldValue(metaobject, 'sku'),
        type: getMetaobjectReferenceName(typeField),
        category: getMetaobjectReferenceName(categoryField) || 'Finishes',
        summaryImage: summaryImage,
        detailImage: detailImage
      };
    }

    function normalizeRenderedFinish(item, categoryName) {
      return {
        name: item.getAttribute('data-finish-name') || '',
        description: item.getAttribute('data-finish-description') || '',
        vendor: item.getAttribute('data-finish-vendor') || '',
        sku: item.getAttribute('data-finish-sku') || '',
        type: item.getAttribute('data-finish-type') || finishType,
        category: item.getAttribute('data-finish-category') || categoryName || 'Finishes',
        summaryImage: item.getAttribute('data-finish-image-summary') || '',
        detailImage: item.getAttribute('data-finish-image-detail') || ''
      };
    }

    function createFinishItem(finish) {
      var item = document.createElement('div');
      var button = document.createElement('button');
      var image = document.createElement('span');
      var name = document.createElement('span');

      item.className = 'fabric-selector__item';
      item.setAttribute('data-finish-option', '');
      item.setAttribute('data-finish-option-name', optionName);
      item.setAttribute('data-finish-type', finishType);
      item.setAttribute('data-finish-value', finish.name);
      item.setAttribute('data-finish-name', finish.name);
      item.setAttribute('data-finish-description', finish.description || '');
      item.setAttribute('data-finish-vendor', finish.vendor || '');
      item.setAttribute('data-finish-sku', finish.sku || '');
      item.setAttribute('data-finish-category', finish.category || '');
      item.setAttribute('data-finish-image-summary', finish.summaryImage || '');
      item.setAttribute('data-finish-image-detail', finish.detailImage || finish.summaryImage || '');

      button.className = 'fabric-selector__select';
      button.type = 'button';
      button.title = finish.name;
      button.setAttribute('data-finish-select-option', '');

      image.className = 'fabric-selector__image';
      image.innerHTML = finish.summaryImage ? finishImageMarkup(finish.summaryImage, finish.name, 180, 'lazy') : '<span class="fabric-selector__image-placeholder"></span>';

      name.className = 'fabric-selector__name uppercase text-13';
      name.textContent = finish.name;

      button.appendChild(image);
      button.appendChild(name);
      item.appendChild(button);

      if (finish.description || finish.vendor || finish.sku) {
        var detailsButton = document.createElement('button');
        detailsButton.className = 'fabric-selector__details-toggle text-sm underline';
        detailsButton.type = 'button';
        detailsButton.setAttribute('data-finish-details-open', '');
        detailsButton.textContent = 'Details';
        item.appendChild(detailsButton);
      }

      bindFinishItem(item);
      return item;
    }

    function findFinishSection(headingText) {
      var sections = nodeList('.fabric-selector__style-section', selector);

      for (var i = 0; i < sections.length; i += 1) {
        var heading = sections[i].querySelector('.fabric-selector__style-heading');

        if (heading && heading.textContent.trim() === headingText) {
          return sections[i];
        }
      }

      return null;
    }

    function renderStorefrontFinishes(finishes) {
      var grouped = {};
      var categoryNames = [];

      if (!dynamicSections) return;
      dynamicSections.innerHTML = '';

      finishes.forEach(function(finish) {
        var categoryName = finish.category || 'Finishes';

        if (!grouped[categoryName]) {
          grouped[categoryName] = [];
          categoryNames.push(categoryName);
        }

        grouped[categoryName].push(finish);
      });

      categoryNames.sort(function(a, b) {
        return a.localeCompare(b);
      });

      categoryNames.forEach(function(categoryName) {
        var section = findFinishSection(categoryName);
        var heading;
        var grid;

        if (!section) {
          section = document.createElement('div');
          heading = document.createElement('h3');
          grid = document.createElement('div');

          section.className = 'fabric-selector__style-section';
          heading.className = 'fabric-selector__style-heading uppercase text-13';
          heading.textContent = categoryName;
          grid.className = 'fabric-selector__grid';
          section.appendChild(heading);
          section.appendChild(grid);
          dynamicSections.appendChild(section);
        } else {
          grid = section.querySelector('.fabric-selector__grid');

          if (!grid) {
            grid = document.createElement('div');
            grid.className = 'fabric-selector__grid';
            section.appendChild(grid);
          }
        }

        grouped[categoryName].sort(function(a, b) {
          return a.name.localeCompare(b.name);
        }).forEach(function(finish) {
          grid.appendChild(createFinishItem(finish));
        });
      });

      finishItems = nodeList('[data-finish-option]', selector);
    }

    function fetchStorefrontFinishMetaobjects(cursor, metaobjects) {
      var query = [
        'query FinishMetaobjects($cursor: String) {',
        '  metaobjects(type: "finishes", first: 250, after: $cursor) {',
        '    pageInfo { hasNextPage endCursor }',
        '    nodes {',
        '      handle',
        '      fields {',
        '        key',
        '        value',
        '        reference {',
        '          ... on Metaobject { handle fields { key value } }',
        '          ... on MediaImage {',
        '            image {',
        '              url',
        '              summaryUrl: url(transform: { maxWidth: 180 })',
        '              detailUrl: url(transform: { maxWidth: 720 })',
        '            }',
        '          }',
        '        }',
        '      }',
        '    }',
        '  }',
        '}'
      ].join('\\n');

      return fetch('/api/' + storefrontApiVersion + '/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontToken
        },
        body: JSON.stringify({
          query: query,
          variables: {
            cursor: cursor || null
          }
        })
      }).then(function(response) {
        return response.json();
      }).then(function(json) {
        if (json.errors) throw new Error(json.errors.map(function(error) { return error.message; }).join(', '));

        var page = json.data && json.data.metaobjects;
        var nextMetaobjects = metaobjects.concat(page && page.nodes ? page.nodes : []);

        if (page && page.pageInfo && page.pageInfo.hasNextPage) {
          return fetchStorefrontFinishMetaobjects(page.pageInfo.endCursor, nextMetaobjects);
        }

        return nextMetaobjects;
      });
    }

    function finishPageUrl(page) {
      var url = new URL(window.location.href);
      url.searchParams.set(finishPaginationParam, page);
      return url.toString();
    }

    function fetchRenderedFinishPage(page) {
      return fetch(finishPageUrl(page), {
        credentials: 'same-origin'
      }).then(function(response) {
        return response.text();
      }).then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fetchedSelector = Array.from(doc.querySelectorAll('[data-finish-selector]')).filter(function(root) {
          return root.getAttribute('data-finish-option-name') === optionName && root.getAttribute('data-finish-type') === finishType;
        })[0];
        var productVendorHandle = normalizeHandle(productVendor);
        var finishTypeHandle = normalizeHandle(finishType);
        var finishes = [];

        if (!fetchedSelector) return finishes;

        nodeList('.fabric-selector__style-section', fetchedSelector).forEach(function(section) {
          var categoryName = section.querySelector('.fabric-selector__style-heading') ? section.querySelector('.fabric-selector__style-heading').textContent.trim() : 'Finishes';

          if (categoryName === 'Featured Finishes') return;

          nodeList('[data-finish-option]', section).forEach(function(item) {
            var finishVendor = item.getAttribute('data-finish-vendor') || '';
            var itemFinishType = item.getAttribute('data-finish-type') || '';

            if (normalizeHandle(finishVendor) === productVendorHandle && normalizeHandle(itemFinishType) === finishTypeHandle) {
              finishes.push(normalizeRenderedFinish(item, categoryName));
            }
          });
        });

        return finishes;
      });
    }

    function fetchRenderedVendorFinishes() {
      var requests = [];

      for (var page = 2; page <= finishPaginationPages; page += 1) {
        requests.push(fetchRenderedFinishPage(page));
      }

      if (!requests.length) return Promise.resolve([]);

      return Promise.all(requests).then(function(results) {
        return results.reduce(function(finishes, pageFinishes) {
          return finishes.concat(pageFinishes);
        }, []);
      });
    }

    function getVendorFinishCount() {
      var productVendorHandle = normalizeHandle(productVendor);
      var count = 0;

      finishItems.forEach(function(item) {
        var finishVendor = item.getAttribute('data-finish-vendor') || '';

        if (normalizeHandle(finishVendor) === productVendorHandle) {
          count += 1;
        }
      });

      return count;
    }

    function loadDynamicVendorFinishes() {
      if (dynamicFinishesLoaded || dynamicFinishesLoading || !dynamicSections) return;
      if (finishPaginationPages <= 1 && !storefrontToken) return;

      dynamicFinishesLoading = true;
      setDynamicStatus('');

      fetchRenderedVendorFinishes().then(function(renderedFinishes) {
        if (renderedFinishes.length || !storefrontToken) return renderedFinishes;

        return fetchStorefrontFinishMetaobjects(null, []).then(function(metaobjects) {
          var productVendorHandle = normalizeHandle(productVendor);
          var finishTypeHandle = normalizeHandle(finishType);

          return metaobjects
            .map(normalizeStorefrontFinish)
            .filter(function(finish) {
              return finish.name && normalizeHandle(finish.vendor) === productVendorHandle && normalizeHandle(finish.type) === finishTypeHandle;
            });
        });
      }).then(function(finishes) {
        var productVendorHandle = normalizeHandle(productVendor);
        var finishTypeHandle = normalizeHandle(finishType);
        var uniqueFinishNames = {};
        var existingVendorFinishCount = getVendorFinishCount();

        finishItems.forEach(function(item) {
          var finishName = item.getAttribute('data-finish-name') || '';
          var finishVendor = item.getAttribute('data-finish-vendor') || '';

          if (finishName && normalizeHandle(finishVendor) === productVendorHandle) {
            uniqueFinishNames[normalizeHandle(finishName)] = true;
          }
        });

        var filteredFinishes = finishes
          .filter(function(finish) {
            return finish.name && normalizeHandle(finish.vendor) === productVendorHandle && normalizeHandle(finish.type || finishType) === finishTypeHandle;
          })
          .filter(function(finish) {
            var key = normalizeHandle(finish.name);
            if (uniqueFinishNames[key]) return false;
            uniqueFinishNames[key] = true;
            return true;
          });

        dynamicFinishesLoaded = true;
        dynamicFinishesLoading = false;

        if (!filteredFinishes.length) {
          if (!existingVendorFinishCount) {
            setDynamicStatus('No finishes found for ' + productVendor + '.');
          }
          return;
        }

        renderStorefrontFinishes(filteredFinishes);
        setDynamicStatus('');
      }).catch(function(error) {
        dynamicFinishesLoading = false;
        setDynamicStatus('Finishes could not be loaded. Please try again.');
        if (window.console) console.warn('Finish selector Storefront API fallback failed:', error);
      });
    }

    function selectFinish(item) {
      selectedFinish = getFinishData(item);
      updateSelectedFinish();
      close();

      if (autoOpenQuote) {
        document.dispatchEvent(new CustomEvent('finish:quote-request', {
          detail: selectedFinish
        }));
      }
    }

    function updateSelectedFinish() {
      var finishName = selectedFinish ? selectedFinish.name : defaultLabel;
      var finishDescription = selectedFinish ? selectedFinish.description : '';
      var finishImage = selectedFinish ? selectedFinish.summaryImage : '';

      selectedLabel.textContent = finishName;
      selector.setAttribute('data-selected-finish', selectedFinish ? finishName : '');
      selector.setAttribute('data-selected-finish-description', finishDescription || '');
      selector.setAttribute('data-selected-finish-vendor', selectedFinish ? selectedFinish.vendor : '');
      selector.setAttribute('data-selected-finish-sku', selectedFinish ? selectedFinish.sku : '');
      selector.setAttribute('data-selected-finish-category', selectedFinish ? selectedFinish.category : '');
      selector.setAttribute('data-selected-finish-image', selectedFinish ? selectedFinish.image : '');

      if (selectedImage) {
        selectedImage.innerHTML = finishImageMarkup(finishImage, finishName, 180, 'lazy');
      }

      finishItems.forEach(function(item) {
        item.classList.toggle('is-selected', selectedFinish && item.getAttribute('data-finish-value') === selectedFinish.value);
      });

      document.dispatchEvent(new CustomEvent('finish:change', {
        detail: selectedFinish || {
          optionName: optionName,
          type: finishType,
          name: '',
          value: ''
        }
      }));
    }

    function getFinishData(item) {
      var detailImage = item.getAttribute('data-finish-image-detail') || '';
      var summaryImage = item.getAttribute('data-finish-image-summary') || detailImage;

      return {
        optionName: optionName,
        type: finishType,
        value: item.getAttribute('data-finish-value') || '',
        name: item.getAttribute('data-finish-name') || '',
        description: item.getAttribute('data-finish-description') || '',
        vendor: item.getAttribute('data-finish-vendor') || '',
        sku: item.getAttribute('data-finish-sku') || '',
        category: item.getAttribute('data-finish-category') || '',
        image: detailImage || summaryImage,
        summaryImage: summaryImage
      };
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function normalizeHandle(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function finishImageMarkup(src, alt, size, loading) {
    if (!src) return '';
    var dimension = size || 180;
    return '<img src="' + escapeHtml(src) + '" width="' + dimension + '" height="' + dimension + '" alt="' + escapeHtml(alt || '') + '" loading="' + (loading || 'lazy') + '" decoding="async">';
  }
})();

/* Product inquire modal */
(function ProductInquireModal() {
  var modal = nodeList('[data-js-inquire-modal]')[0];
  var triggerOpen = nodeList('[data-js-inquire-open]');
  var quoteOpen = nodeList('[data-js-quote-open]');
  var triggerClose = nodeList('[data-js-inquire-close]');
  var finishChange = nodeList('[data-inquiry-finish-change]');
  var variantQuoteDataNode = document.querySelector('[data-variant-quote-data]');
  var variantQuoteData = variantQuoteDataNode ? JSON.parse(variantQuoteDataNode.innerHTML) : {};
  var variantSelect = null;
  var inquiryContext = null;
  var showEstimatedPricing = true;
  if (!modal) return;
  
  triggerOpen.forEach(function(node){
    node.addEventListener('click', open);
  });

  quoteOpen.forEach(function(node){
    node.addEventListener('click', openQuote);
  });
	  
  triggerClose.forEach(function(node){
    node.addEventListener('click', close);
  });

  finishChange.forEach(function(node) {
    node.addEventListener('click', openFinishPanel);
  });

  document.addEventListener('variant:change', syncInquiryFields);
  document.addEventListener('fabric:change', syncInquiryFields);
  document.addEventListener('fabric:quote-request', function(event) {
    openQuoteWithSelections({
      fabric: event.detail || getSelectedFabric()
    });
  });
  document.addEventListener('fabric:panel-close', positionModal);
  document.addEventListener('finish:change', syncInquiryFields);
  document.addEventListener('finish:quote-request', function() {
    openQuoteWithSelections({
      finishes: getSelectedFinishes()
    });
  });
  document.addEventListener('finish:panel-close', positionModal);

  variantSelect = modal.querySelector('[data-inquiry-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', changeVariantFromModal);
  }

  syncInquiryFields();

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function fabricImageMarkup(src, alt, size, loading) {
    if (!src) return '';
    var dimension = size || 200;
    return '<img src="' + escapeHtml(src) + '" width="' + dimension + '" height="' + dimension + '" alt="' + escapeHtml(alt || '') + '" loading="' + (loading || 'lazy') + '" decoding="async">';
  }
	  
  function open(event) {
    var trigger = event && event.currentTarget ? event.currentTarget : null;
    inquiryContext = getInquiryContext(trigger);
    syncInquiryFields();
    positionModal();
    modal.removeAttribute('hidden');
  }

  function openQuote() {
    openQuoteWithSelections();
  }

  function openQuoteWithSelections(context) {
    var fabric = context && context.fabric ? context.fabric : getSelectedFabric();
    var finishes = context && context.finishes ? context.finishes : getSelectedFinishes();

    if (isMissingFabric(fabric)) {
      openFabricPanel();
      return;
    }

    if (isMissingFinish(finishes)) {
      openFinishPanel();
      return;
    }

    inquiryContext = {
      fabric: fabric,
      finishes: finishes
    };
    syncInquiryFields();
    positionModal();
    modal.removeAttribute('hidden');
  }
	  
  function close() {
    modal.setAttribute('hidden', true);
    modal.classList.remove('is-beside-fabric-panel');
  }

  function syncInquiryFields() {
    var productInput = modal.querySelector('[data-inquiry-product]');
    var variantInput = modal.querySelector('[data-inquiry-variant]');
    var fabricInput = modal.querySelector('[data-inquiry-fabric]');
    var fabricLabel = modal.querySelector('[data-inquiry-fabric-label]');
    var fabricLabelField = modal.querySelector('[data-inquiry-fabric-label-field]');
    var finishInput = modal.querySelector('[data-inquiry-finish]');
    var finishLabel = modal.querySelector('[data-inquiry-finish-label]');
    var finishLabelField = modal.querySelector('[data-inquiry-finish-label-field]');
    var productLabel = modal.querySelector('[data-inquiry-product-label]');
    var variantImage = modal.querySelector('[data-inquiry-variant-image]');
    var fabricImage = modal.querySelector('[data-inquiry-fabric-image]');
    var finishImage = modal.querySelector('[data-inquiry-finish-image]');
    var fabricDescriptionInput = modal.querySelector('[data-inquiry-fabric-description]');
    var finishDescriptionInput = modal.querySelector('[data-inquiry-finish-description]');
    var finishVendorInput = modal.querySelector('[data-inquiry-finish-vendor]');
    var finishSkuInput = modal.querySelector('[data-inquiry-finish-sku]');
    var finishCategoryInput = modal.querySelector('[data-inquiry-finish-category]');
    var productUrlInput = modal.querySelector('[data-inquiry-product-url]');
    var estimate = modal.querySelector('[data-inquiry-estimated-price]');
    var estimateField = modal.querySelector('[data-inquiry-estimated-price-field]');
    var yardageField = modal.querySelector('[data-inquiry-yardage-field]');
    var mainVariantSelect = document.querySelector('[data-main-select]');
    var selectedVariantId = mainVariantSelect ? mainVariantSelect.value : '';
    var selectedVariant = mainVariantSelect && mainVariantSelect.options[mainVariantSelect.selectedIndex] ? mainVariantSelect.options[mainVariantSelect.selectedIndex].text.trim() : '';
    var selectedVariantData = variantQuoteData[selectedVariantId] || {};
    var fabric = inquiryContext && inquiryContext.fabric ? inquiryContext.fabric : getSelectedFabric();
    var finishes = inquiryContext && inquiryContext.finishes ? inquiryContext.finishes : getSelectedFinishes();
    var fabricName = fabric.name || '';
    var fabricDescription = fabric.description || '';
    var finishName = finishSummary(finishes);
    var finishDescription = finishDescriptionSummary(finishes);
    var primaryFinish = selectedFinishesOnly(finishes)[0] || {};

    if (inquiryContext) {
      if (inquiryContext.variantName) selectedVariant = inquiryContext.variantName;
      if (inquiryContext.fabricName) fabricName = inquiryContext.fabricName;
      if (inquiryContext.fabricDescription) fabricDescription = inquiryContext.fabricDescription;
      if (inquiryContext.finishName) finishName = inquiryContext.finishName;
      if (inquiryContext.finishDescription) finishDescription = inquiryContext.finishDescription;
    }

    if (productInput) productInput.value = productInput.getAttribute('data-product-title') || productInput.value;
    if (productLabel && productInput) productLabel.textContent = productInput.value;
    if (variantInput) variantInput.value = selectedVariant;
    if (variantSelect && selectedVariantId) variantSelect.value = selectedVariantId;
    if (fabricInput) fabricInput.value = fabricName || '';
    if (fabricLabel) fabricLabel.textContent = fabricName || 'Select Covering';
    if (fabricLabelField) fabricLabelField.textContent = fabricName || 'Select Covering';
    if (fabricDescriptionInput) fabricDescriptionInput.value = fabricDescription || '';
    if (finishInput) finishInput.value = finishName || '';
    if (finishLabel) finishLabel.textContent = finishName || 'Select Finish';
    if (finishLabelField) finishLabelField.textContent = finishName || 'Select Finish';
    if (finishDescriptionInput) finishDescriptionInput.value = finishDescription || '';
    if (finishVendorInput) finishVendorInput.value = uniqueFinishValues(finishes, 'vendor');
    if (finishSkuInput) finishSkuInput.value = selectedFinishesOnly(finishes).map(function(item) {
      return item.sku ? item.optionName + ': ' + item.sku : '';
    }).filter(Boolean).join('; ');
    if (finishCategoryInput) finishCategoryInput.value = selectedFinishesOnly(finishes).map(function(item) {
      return item.category ? item.optionName + ': ' + item.category : '';
    }).filter(Boolean).join('; ');
    if (productUrlInput) productUrlInput.value = window.location.href;
    if (variantImage) variantImage.innerHTML = fabricImageMarkup(selectedVariantData.image, selectedVariant, 200, 'lazy');
    if (fabricImage) fabricImage.innerHTML = fabricImageMarkup(fabric.image, fabricName, 200, 'lazy');
    if (finishImage) finishImage.innerHTML = fabricImageMarkup(primaryFinish.image, primaryFinish.name, 200, 'lazy');
    if (yardageField) yardageField.value = selectedVariantData.yardage ? selectedVariantData.yardage + ' yards' : '';

    updateEstimate(estimate, estimateField, selectedVariantData, fabric);
  }

  function getInquiryContext(trigger) {
    if (!trigger || !trigger.hasAttribute('data-custom-fabric-inquiry')) return null;

    return {
      variantName: trigger.getAttribute('data-inquiry-variant-name') || 'Custom',
      fabricName: trigger.getAttribute('data-inquiry-fabric-name') || '',
      fabricDescription: trigger.getAttribute('data-inquiry-fabric-description') || '',
      finishName: trigger.getAttribute('data-inquiry-finish-name') || '',
      finishDescription: trigger.getAttribute('data-inquiry-finish-description') || ''
    };
  }

  function getSelectedFabric() {
    var fabricSelector = document.querySelector('[data-fabric-selector]');
    if (!fabricSelector) return {};

    return {
      name: fabricSelector.getAttribute('data-selected-fabric') || '',
      description: fabricSelector.getAttribute('data-selected-fabric-description') || '',
      retailPrice: fabricSelector.getAttribute('data-selected-fabric-retail-price') || '',
      vendor: fabricSelector.getAttribute('data-selected-fabric-vendor') || '',
      sku: fabricSelector.getAttribute('data-selected-fabric-sku') || '',
      image: fabricSelector.getAttribute('data-selected-fabric-image') || ''
    };
  }

  function getSelectedFinishes() {
    return nodeList('[data-finish-selector]').map(function(finishSelector) {
      return {
        optionName: finishSelector.getAttribute('data-finish-option-name') || 'Finish',
        type: finishSelector.getAttribute('data-finish-type') || '',
        name: finishSelector.getAttribute('data-selected-finish') || '',
        description: finishSelector.getAttribute('data-selected-finish-description') || '',
        vendor: finishSelector.getAttribute('data-selected-finish-vendor') || '',
        sku: finishSelector.getAttribute('data-selected-finish-sku') || '',
        category: finishSelector.getAttribute('data-selected-finish-category') || '',
        image: finishSelector.getAttribute('data-selected-finish-image') || ''
      };
    });
  }

  function isMissingFabric(fabric) {
    var fabricSelector = document.querySelector('[data-fabric-selector]');
    if (!fabricSelector) return false;

    return !fabric || !fabric.name || fabric.name === 'Select Covering';
  }

  function isMissingFinish(finishes) {
    if (!document.querySelector('[data-finish-selector]')) return false;

    return !finishes.length || finishes.some(function(finish) {
      return !finish.name;
    });
  }

  function openFabricPanel() {
    var fabricOpen = document.querySelector('[data-fabric-panel-open]');
    if (fabricOpen) fabricOpen.click();
  }

  function openFinishPanel() {
    var missingSelector = nodeList('[data-finish-selector]').filter(function(selector) {
      return !(selector.getAttribute('data-selected-finish') || '');
    })[0];
    var finishOpen = missingSelector ? missingSelector.querySelector('[data-finish-panel-open]') : document.querySelector('[data-finish-panel-open]');
    if (finishOpen) finishOpen.click();
  }

  function selectedFinishesOnly(finishes) {
    return (finishes || []).filter(function(finish) {
      return finish && finish.name;
    });
  }

  function finishSummary(finishes) {
    var selected = selectedFinishesOnly(finishes);
    if (!selected.length) return '';

    return selected.map(function(finish) {
      return finish.optionName + ': ' + finish.name;
    }).join('; ');
  }

  function finishDescriptionSummary(finishes) {
    return selectedFinishesOnly(finishes).map(function(finish) {
      return finish.description ? finish.optionName + ': ' + finish.description : '';
    }).filter(Boolean).join('\n');
  }

  function uniqueFinishValues(finishes, key) {
    var seen = {};
    return selectedFinishesOnly(finishes).map(function(finish) {
      return finish[key] || '';
    }).filter(function(value) {
      if (!value || seen[value]) return false;
      seen[value] = true;
      return true;
    }).join('; ');
  }

  function changeVariantFromModal() {
    var mainVariantSelect = document.querySelector('[data-main-select]');
    if (!mainVariantSelect || !variantSelect) return;

    mainVariantSelect.value = variantSelect.value;
    mainVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    syncInquiryFields();
  }

  function updateEstimate(estimate, estimateField, variantData, fabric) {
    if (!estimate || !estimateField) return;

    var fabricPrice = parsePrice(fabric.retailPrice);
    var yardage = parsePrice(variantData.yardage);

    if (!showEstimatedPricing || !variantData.price || !fabricPrice || !yardage) {
      if (fabric.name === 'COM' && yardage) {
        estimate.innerHTML = '<strong>Yardage required: ' + yardage + ' yards</strong>';
        estimateField.value = '';
        estimate.removeAttribute('hidden');
        return;
      }

      estimate.setAttribute('hidden', true);
      estimateField.value = '';
      return;
    }

    var estimateCents = Number(variantData.price) + Math.round(fabricPrice * yardage * 100);
    var estimateText = formatMoney(estimateCents);

    estimate.innerHTML = '<strong>Estimated price: ' + estimateText + '</strong><br><span>This is an estimate only. Official quote required to confirm final pricing.</span>';
    estimateField.value = estimateText + ' estimate only';
    estimate.removeAttribute('hidden');
  }

  function parsePrice(value) {
    if (value === null || value === undefined) return 0;
    return Number(String(value).replace(/[^0-9.]/g, '')) || 0;
  }

  function positionModal() {
    var fabricPanel = document.querySelector('[data-fabric-panel]');
    var fabricPanelOpen = fabricPanel && !fabricPanel.hasAttribute('hidden') && !fabricPanel.classList.contains('is-closing');
    var finishPanelOpen = nodeList('[data-finish-panel]').some(function(finishPanel) {
      return !finishPanel.hasAttribute('hidden') && !finishPanel.classList.contains('is-closing');
    });

    modal.classList.toggle('is-beside-fabric-panel', Boolean(fabricPanelOpen || finishPanelOpen));
  }
})();

/* Product modal */
(function ProductGallery() {
  var instance = document.querySelector('[data-product-gallery]');
  if (!instance) return;
  
  var swiper = new Swiper('[data-product-gallery]', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    breakpoints: {
      840: {
        cssMode: false,
        spaceBetween: 0
      }
    }
  });
  
  theme = theme || {}
  theme.productGallery = swiper;

  var thumbs = nodeList('[data-product-gallery-thumb]');

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', partial(selectThumb, thumb));
  });

  swiper.on('slideChange', function() {
    setActiveThumb(swiper.activeIndex);
  });

  function selectThumb(thumb) {
    var index = Number(thumb.getAttribute('data-product-gallery-thumb-index'));
    swiper.slideTo(index);
    setActiveThumb(index);
  }

  function setActiveThumb(index) {
    thumbs.forEach(function(thumb) {
      var thumbIndex = Number(thumb.getAttribute('data-product-gallery-thumb-index'));
      thumb.classList.toggle('is-active', thumbIndex === index);
    });
  }
})();

(function ProductModalGallery() {
  var modal = document.querySelector('[data-js-gallery-modal]');
  var triggerOpen = nodeList('[data-image-id]');
  var triggerClose = document.querySelector('[data-js-gallery-close]');
  
  triggerOpen.forEach(function(node){
    node.addEventListener('click', partial(open, node));
  });
  
  triggerClose.addEventListener('click', close);
  
  function open(image) {
    var id = image.getAttribute('data-image-id');
    modal.removeAttribute('hidden');
    initSwiper(position);
    
    var modalImage = modal.querySelector('[data-id="' + id + '"] ')
    var position = modalImage.getAttribute('data-index');
    theme.modalProductGallery.slideTo(position);
    theme.modalProductGalleryThumbs.slideTo(position);
  }
  
  function close() {
    modal.setAttribute('hidden', true);
  }
  
  function initSwiper(position) {
    var instance = document.querySelector('[data-gallery-modal]');
    if (!instance.classList.contains('swiper-container-initialized')) {
      var swiperThumbs = new Swiper('[data-gallery-modal-thumbs]', {
        slidesPerView: 4,
        spaceBetween: 0,
        centeredSlides: false,
        initialSlide: position,
         breakpoints: {
          840: {
            slidesPerView: 9,
            centeredSlides: true
          }
        }
      });
      
      var swiper = new Swiper('[data-gallery-modal]', {
        spaceBetween: 0,
        slidesPerView: 1,
        initialSlide: position,
        navigation: {
          nextEl: '.slider-btn-next',
          prevEl: '.slider-btn-prev'
        },
        thumbs: {
          swiper: swiperThumbs,
          autoScrollOffset: 1
        },
        
       breakpoints: {
          840: {
            thumbs: {
              autoScrollOffset: 4
            }
          }
        }
        
      });
      
      theme.modalProductGallery = swiper;
      theme.modalProductGalleryThumbs = swiperThumbs;
    }
  }
})();
